import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SessionService } from '@core/services/session.service';
import { HomeUserBannerComponent } from './home-user-banner/home-user-banner.component';
import { HomeSlidesComponent } from './home-slides/home-slides.component';
import { HomeGamesComponent } from './home-games/home-games.component';
import { LiveBetsTableComponent } from '../live-bets/components/live-bets-table/live-bets-table.component';
import { LiveBetsService } from '@features/live-bets/services/live-bets.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AffiliatesService } from '@features/affiliates/services/affiliates.service';
import { ModalService } from '@features/modals/services/modal.service';

@Component({
  selector: 'app-home',
  imports: [
    HomeUserBannerComponent,
    HomeSlidesComponent,
    HomeGamesComponent,
    LiveBetsTableComponent,
  ],
  standalone: true,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col items-center justify-center container',
  },
})
export class HomeComponent {
  public sessionService = inject(SessionService);
  public liveBetsService = inject(LiveBetsService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private affiliatesService = inject(AffiliatesService);
  private modalService = inject(ModalService);

  constructor() {
    const promoCode = this.route.snapshot.params['promoCode'];

    if (promoCode) {
      this.handlePromoCode(promoCode);
    }
  }

  private async handlePromoCode(promoCode: string): Promise<void> {
    try {
      await this.affiliatesService.usePromoCode(promoCode);
    } catch (error) {
      this.router.navigate(['/deposit']);
      this.modalService.openModal('ReedemPromocodeModalComponent', {
        initialCode: promoCode,
        errors: { api: error as string, required: null },
      });
    }
  }
}
